/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const Bar = (props) => {
  const getOption = () => {
    let theme = props.selectedThemeing;
    let option = {
      interval: props.graphprops.bar ? props.graphprops.bar['Interval'] : '',
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [
          {
            name: 'test1',
            icon: 'roundRect'
          }
        ]
      },
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: theme === 'lightTheme' ? 'black' : 'black',
            title: 'download',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      xAxis: {
        type: 'category',
        data: props.graphprops,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          },
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          interval: 0,
          rotate: 90
        }
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,

          backgroundColor: '#9a9191',
          textStyle: {
            color: 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ]
    };
    return option;
  };
  const [option, setOption] = useState(getOption());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  let requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    translationCache,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    translationCache
  ]);

  const removeDuplicateObjectsByKey = (array, fieldToDuplicateCheck) => {
    const newArray = [];
    const arrayKeys = [];
    array.forEach((item) => {
      if (!arrayKeys.includes(item[fieldToDuplicateCheck])) {
        arrayKeys.push(item[fieldToDuplicateCheck]);
        newArray.push(item);
      }
    });
    return newArray;
  };

  const addYAxisIndex = (data, config, translationCache) => {
  const yAxisConfig = JSON.parse(config.YAxis);
  const tagsToIndex = {};

  yAxisConfig.forEach((axis, idx) => {
    axis.tags.forEach(tag => {
      // Translate tag if needed
      const translatedTag = translationCache[tag] || tag;
      tagsToIndex[translatedTag] = idx;
    });
  });

  data.forEach(entry => {
    if (entry.name && tagsToIndex[entry.name] !== undefined) {
      entry.yAxisIndex = tagsToIndex[entry.name];
    }
  });

  return data;
}

  const getData = async (props) => {
    let theme = props.selectedThemeing;
    requestCheck.current = false;
    let errorInAPI = false;
    let noDataInDB = false;
    let json = [];
    let { graphprops } = props;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck = true;
    } else {
      if (props.graphprops.graph === 'rangeBar' && props.graphprops.currentDateData !== undefined) {
        json = props.graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      let dates = [];
      let values = [];
      let name = '';
      let Names = [];
      let seriesarray = [];
      let legendsdata = [];
      let showLabel = false;
      let showStack = false;
      let viewType = '';

      let { graphprops } = props;
      if (graphprops && graphprops.bar && graphprops.bar['showLabel']) {
        showLabel = graphprops.bar['showLabel'] || false;
      }
      if (graphprops && graphprops.bar && graphprops.bar['showStack']) {
        showStack = graphprops.bar['showStack'] || false;
      }
      if (graphprops && graphprops.bar && graphprops.bar['viewType']) {
        viewType = graphprops.bar['viewType'] || 'vertical';
      }
      let descriptionList = [];
      json &&
        Array.isArray(json) &&
        json.map((val) => {
          if (val.Description && val.Description !== name) {
            if (Names.indexOf(val.Description) === -1) {
              Names.push(val.Description);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
              descriptionList = [...descriptionList, val.Description];
            }
          }
          return {};
        });
      let descriptionListDuplicate = [];
      descriptionListDuplicate = removeDuplicateObjectsByKey(descriptionList, 'Name');

      let yAxisData = [];
      if (
        props &&
        props.graphprops &&
        props.graphprops[props.graphprops.graph] &&
        props.graphprops[props.graphprops.graph].YAxis
      ) {
        let jsonValue =
          props &&
          props.graphprops &&
          props.graphprops[props.graphprops.graph] &&
          props.graphprops[props.graphprops.graph].YAxis;
        yAxisData = jsonValue ? JSON.parse(jsonValue) : [];
      } else {
        yAxisData = [];
      }

      let yaxis = yAxisData && Array.isArray(yAxisData) && yAxisData.map((value, index) => {
        let axis = {};
        axis.splitLine = {
          show: false,
          lineStyle: {
            color: '#504c4c'
          }
        };
        axis.triggerEvent = true;
        axis.axisLine = {
          show: true,
          lineStyle: {
            color:
              props.graphprops &&
                props.graphprops[props.graphprops.graph] &&
                props.graphprops[props.graphprops.graph].colors &&
                props.graphprops[props.graphprops.graph].colors[index] !== undefined
                ? value && value.tags && value.tags.length > 1
                  ? 'white'
                  : props.graphprops &&
                  props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].colors &&
                  props.graphprops[props.graphprops.graph].colors[index]
                : 'white'

          }
        };
        axis.max = value.max;
        axis.min = value.min;
        axis.offset = value.offset;
        axis.interval = value.interval;
        axis.position = value.position;
        axis.name = value.name;
        axis.tags = value.tags;
        return axis;
      });
      if (
        props &&
        props.graphprops &&
        props.graphprops.title !== 'Cylinder Force vs Retracting  & Extending Time' &&
        props.graphprops.title !== 'Power Generation' &&
        props.graphprops.title !== 'Power Generation Previous Day'
      ) {
        yaxis && yaxis.unshift({
          splitLine: {
            show: false,
            lineStyle: {
              color: '#504c4c'
            }
          },
          triggerEvent: true,
          axisLine: {
            show: true,
            lineStyle: {
              color:
                props.graphprops &&
                  props.graphprops.bar &&
                  props.graphprops.bar.Linecolor &&
                  props.graphprops.bar.Linecolor.length > 0
                  ? props.graphprops.bar.Linecolor[0]
                  : 'white'
            }
          },
          axisLabel: { fontSize: 15 },
          tags: []
        });
      }

      Names.map((tagval, tagindex) => {
        values = [];
        json.map((jsonval) => {
          if (Names[0] === jsonval.Description && tagindex === 0) {
            let date = {};
            if (
              props.graphprops.monthExists === 'true' ||
              props.graphprops.monthExists === true
            ) {
              date =
                graphprops && graphprops.type === 'live'
                  ? moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYY')
                  : moment(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYYY');
            } else {
              if (
                graphprops &&
                graphprops.bar &&
                graphprops.bar.XAxisType &&
                graphprops.bar.XAxisType === 'string'
              ) {
                date = jsonval.DateTime;
              } else {
                let format =
                  graphprops.bar && graphprops.bar.xAxisDateFormat
                    ? graphprops.bar.xAxisDateFormat
                    : 'YYYY-MM-DD HH:mm:ss';

                if (
                  props.graphprops &&
                  props.graphprops.GraphLevelSelection &&
                  props.graphprops.GraphLevelSelection === 'dateMonthYearPicker'
                ) {
                  if (props.dayMonthYear && props.dayMonthYear.SelectionType === 'Day') {
                    date =
                      graphprops && graphprops.type === 'summary'
                        ? moment.utc(jsonval.DateTime).format('HH:mm')
                        : moment
                          .utc(jsonval.DateTime)
                          .tz(props.currentTimeZone)
                          .format('HH:mm');
                  } else if (
                    props.dayMonthYear &&
                    props.dayMonthYear.SelectionType === 'Month'
                  ) {
                    date =
                      graphprops && graphprops.type === 'summary'
                        ? moment.utc(jsonval.DateTime).format('DD/MM')
                        : moment
                            .utc(jsonval.DateTime)
                            .tz(props.currentTimeZone)
                            .format('DD/MM');
                  } else if (
                    props.dayMonthYear &&
                    props.dayMonthYear.SelectionType === 'Year'
                  ) {
                    date =
                      graphprops && graphprops.type === 'summary'
                        ? moment.utc(jsonval.DateTime).format('MMMM')
                        : moment
                          .utc(jsonval.DateTime)
                          .tz(props.currentTimeZone)
                          .format('MMMM');
                  }
                } else {
                  date =
                    graphprops && graphprops.type === 'summary'
                      ? moment.utc(jsonval.DateTime).format(format)
                      : moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format(format);
                }
              }
            }
            if (
              graphprops &&
              graphprops[graphprops.graph] &&
              graphprops[graphprops.graph].showDescInYAxis &&
              graphprops[graphprops.graph].showDescInYAxis === 'Description'
            ) {
              dates.push(jsonval.Description);
            } else {
              dates.push(date);
            }
          }
          if (tagval === jsonval.Description) {
            if (
              graphprops &&
              graphprops[graphprops.graph] &&
              graphprops[graphprops.graph].showDescInYAxis &&
              graphprops[graphprops.graph].showDescInYAxis === 'Description'
            ) {
              values.push({
                value: jsonval.Value,
                name: jsonval.Description,
                percentage: jsonval.percentage
              });
            } else {
              values.push(jsonval.Value);
            }
          }
          return {};
        });
        if (yaxis.length > 1) {
          yaxis && Array.isArray(yaxis) &&
            yaxis.map((axis, axisindex) => {
              if (axis && axis.tags && axis.tags.indexOf(tagval) === -1) {
                let linetags =
                  props.graphprops && props.graphprops.bar ? props.graphprops.bar.tags : [];
                if (linetags && linetags.length > 0) {
                  linetags &&
                    linetags.map((tag) => {
                      seriesarray.push({
                        name: legendsdata[tagindex]['name'],
                        data: values,
                        yAxisIndex: axisindex,
                        ...(showStack && showStack === 'true' ? { stack: 'total' } : {}),
                        label: {
                          show:
                            showLabel && (showLabel === 'true' || showLabel === true) ? true : false
                        },
                        markPoint: {
                          data: props.graphprops.minMax
                            ? [
                              { type: 'max', name: 'Max' },
                              { type: 'min', name: 'Min' }
                            ]
                            : null
                        },
                        type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'line',
                        axisLabel: { fontSize: 15 }
                      });
                      return {};
                    });
                } else {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    yAxisIndex: axisindex,
                    type: 'bar',
                    axisLabel: { fontSize: 15 }
                  });
                }
              }
              return {};
            });
        } else {
          let linetags = props.graphprops && props.graphprops.bar ? props.graphprops.bar.tags : [];
          if (linetags && linetags.length > 0) {
            linetags &&
              linetags.map((tag) => {
                seriesarray.push({
                  name: legendsdata[tagindex]['name'],
                  data: values,
                  type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'line',
                  axisLabel: { fontSize: 15 }
                });
                return {};
              });
          } else {
            if (
              graphprops &&
              graphprops[graphprops.graph] &&
              graphprops[graphprops.graph].showDescInYAxis &&
              graphprops[graphprops.graph].showDescInYAxis === 'Description'
            ) {
              seriesarray = {
                axisLabel: { fontSize: 15 },
                type: 'bar',
                data: values
              };
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'bar',
                axisLabel: { fontSize: 15 },
                ...(showStack && showStack === 'true' ? { stack: 'Total' } : { stack: '' }),
                label: {
                  show: showLabel && (showLabel === 'true' || showLabel === true) ? true : false,
                  position: 'inside'
                }
              });
            }
          }
        }

        return {};
      });
      const option = cloneDeep(getOption());
      let series = await trendLabelTranslation(seriesarray, translationCache);
      if (
        props.graphprops &&
        props.graphprops.bar &&
        props.graphprops.bar.colors &&
        props.graphprops.bar.colors.length > 0
      ) {
        option.color = [...props.graphprops.bar.colors];
      }
      if (viewType === 'horizontal') {
        option.xAxis = yaxis && Array.isArray(yaxis) ? [...yaxis] : yaxis;
        option.yAxis.data = Array.isArray(descriptionListDuplicate)
          ? { ...descriptionListDuplicate }
          : descriptionListDuplicate || {};
      } else {
        option.xAxis.data = dates && Array.isArray(dates) ? [...dates] : dates;
        option.yAxis = Array.isArray(yaxis) && Object.keys(yaxis).length > 0 && yaxis !== null
          ? yaxis && { ...yaxis } && yaxis
          : { ...yaxis } || {};
      }
      if (props.graphprops.bar && props.graphprops.bar.YAxis) {
          const seriesDataa = addYAxisIndex(series, props.graphprops.bar, translationCache);
          series = seriesDataa
        }
      option.series = series && Array.isArray(series) ? [...series] : series;
      option.legend = legendsdata && Array.isArray(legendsdata) ? [...legendsdata] : legendsdata;
      setOption(option);
      setRefreshDateTime(moment());


    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '80%', width: '100%' }}
          className="react_for_echarts"
          theme="light"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(Bar);
